import { defineTrpcContract, mutation, query } from "@amtana/module";

import {
  enrichmentPreviewSchema,
  enrichmentRequestSchema,
  enrichmentRunSchema,
  runIdInputSchema,
} from "./enrichment.schemas.ts";

export const enrichmentTrpcContract = defineTrpcContract("enrichment", {
  preview: query({ input: enrichmentRequestSchema, output: enrichmentPreviewSchema }),
  get: query({ input: runIdInputSchema, output: enrichmentRunSchema }),
  start: mutation({ input: enrichmentRequestSchema, output: enrichmentRunSchema }),
  cancel: mutation({ input: runIdInputSchema, output: enrichmentRunSchema }),
});
